import { render, staticRenderFns } from "./PayAllNew.vue?vue&type=template&id=4b584795&scoped=true"
import script from "./PayAllNew.vue?vue&type=script&lang=js"
export * from "./PayAllNew.vue?vue&type=script&lang=js"
import style0 from "./PayAllNew.vue?vue&type=style&index=0&id=4b584795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b584795",
  null
  
)

export default component.exports